const viewport = {
  content: "width=device-width, initial-scale=1.0, user-scalable=no",
};

const newPath = [
  {
    path: "/workspace/forms",
    name: "forms",
    component: () => import("@/views/wflow/workspace/oa/FromsApp.vue"),
    meta: { title: "发起审批", viewport: viewport, hasBack: false },
  },
  {
    path: "/myapproval",
    name: "myapproval",
    meta: {
      hasBack: false,
    },
    component: () => import("@/views/wflow/MyApproval.vue"),
    children: [
      {
        path: "workspace/unfinished",
        name: "unfinished",
        component: () => import("@/views/wflow/workspace/oa/UnFinished.vue"),
        meta: {
          title: "我的审批-待处理",
          viewport: viewport,
          hasBack: false,
          activeMenu: "/myapproval/workspace/unfinished",
        },
      },
      {
        path: "workspace/finished",
        name: "finished",
        component: () => import("@/views/wflow/workspace/oa/Finished.vue"),
        meta: {
          title: "我的审批-已处理",
          viewport: viewport,
          hasBack: false,
          activeMenu: "/myapproval/workspace/unfinished",
        },
      },
      {
        path: "workspace/submit",
        name: "submit",
        component: () => import("@/views/wflow/workspace/oa/MySubmit.vue"),
        meta: {
          title: "我的审批-我发起",
          viewport: viewport,
          hasBack: false,
          activeMenu: "/myapproval/workspace/unfinished",
        },
      },
      {
        path: "workspace/cc",
        name: "cc",
        component: () => import("@/views/wflow/workspace/oa/CcMe.vue"),
        meta: {
          title: "我的审批-抄送我的",
          viewport: viewport,
          hasBack: false,
          activeMenu: "/myapproval/workspace/unfinished",
        },
      },
    ],
  },

  // {
  //   path: "/workspace/unfinished",
  //   name: "unfinished",
  //   component: () => import("@/views/wflow/workspace/oa/UnFinished.vue"),
  //   meta: { title: '我的审批-待处理', viewport: viewport },
  // },
  // {
  //   path: "/workspace/finished",
  //   name: "finished",
  //   component: () => import("@/views/wflow/workspace/oa/Finished.vue"),
  //   meta: { title: '我的审批-已处理', viewport: viewport },
  // },
  // {
  //   path: "/workspace/submit",
  //   name: "submit",
  //   component: () => import("@/views/wflow/workspace/oa/MySubmit.vue"),
  //   meta: { title: '我的审批-我发起', viewport: viewport },
  // },
  // {
  //   path: "/workspace/cc",
  //   name: "cc",
  //   component: () => import("@/views/wflow/workspace/oa/CcMe.vue"),
  //   meta: { title: '我的审批-抄送我的', viewport: viewport },
  // },
  {
    path: "/workspace/instances",
    name: "instances",
    component: () => import("@/views/wflow/admin/ProcessInstanceManage.vue"),
    meta: { title: "审批中心", viewport: viewport, hasBack: false },
  },
  {
    path: "/workspace/formsPanel",
    name: "formsPanel",
    component: () => import("@/views/wflow/admin/FormsPanel.vue"),
    meta: { title: "流程管理", viewport: viewport, hasBack: false },
  },
  {
    path: "/workspace/subProcess",
    name: "subProcess",
    component: () => import("@/views/wflow/admin/SubProcess.vue"),
    meta: {
      title: "子流程管理",
      viewport: viewport,
      activeMenu: "/workspace/formsPanel",
    },
  },
];

export default [
  {
    path: "/mbinitiate",
    name: "mbinitiate",
    component: () => import("@/views/wflow/workspace/MbInitiateProcess.vue"),
    meta: {
      title: "wflow-pro | 发起审批",
      viewport: viewport,
      activeMenu: "/workspace/formsPanel",
    },
  },
  {
    path: "/mbInstance",
    name: "mbInstance",
    component: () => import("@/views/wflow/workspace/MbInstanceViewer.vue"),
    meta: {
      title: "wflow-pro | 流程详情",
      viewport: viewport,
      activeMenu: "/workspace/formsPanel",
    },
  },
  {
    path: "/admin/design",
    name: "design",
    component: () => import("@/views/wflow/admin/FormProcessDesign.vue"),
    meta: {
      title: "wflow-pro | 表单流程设计",
      viewport: viewport,
      hasBack: false,
      activeMenu: "/workspace/formsPanel",
    },
  },
  {
    path: "/admin/design/subProcess",
    name: "subProcess",
    component: () =>
      import("@/views/wflow/admin/subProcess/SubProcessDesign.vue"),
    meta: {
      title: "wflow-pro | 子流程设计",
      viewport: viewport,
      activeMenu: "/workspace/formsPanel",
    },
  },
  {
    path: "/testForm",
    name: "testForm",
    component: () => import("@/views/wflow/common/form/TestForm.vue"),
    meta: {
      title: "wflow-pro | 表单演示",
      viewport: viewport,
      activeMenu: "/workspace/formsPanel",
    },
  },
  ...newPath,
];
